module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('v-form-table', {
    staticClass: "product-table",
    attrs: {
      "form": _vm.form,
      "list": _vm.shippingProviders,
      "create": _vm.save,
      "update": _vm.update,
      "destroy": _vm.destroy,
      "translation": "table.shippingProviders",
      "clickHandler": _vm.tableClickHandler
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cbf9512a","hasScoped":false}!./src/app/components/shippingProviderTable/shippingProviderTable.html
// module id = 3124
// module chunks = 1